/* eslint-disable */
'use strict';

/*

Main javascript functions to init most of the elements

#1. CHAT APP
#2. CALENDAR INIT
#3. FORM VALIDATION
#4. DATE RANGE PICKER
#5. DATATABLES
#6. EDITABLE TABLES
#7. FORM STEPS FUNCTIONALITY
#8. SELECT 2 ACTIVATION
#9. CKEDITOR ACTIVATION
#10. CHARTJS CHARTS http://www.chartjs.org/
#11. MENU RELATED STUFF
#12. CONTENT SIDE PANEL TOGGLER
#13. EMAIL APP
#14. FULL CHAT APP
#15. CRM PIPELINE
#16. OUR OWN CUSTOM DROPDOWNS 
#17. BOOTSTRAP RELATED JS ACTIVATIONS
#18. TODO Application

*/

// ------------------------------------
// HELPER FUNCTIONS TO TEST FOR SPECIFIC DISPLAY SIZE (RESPONSIVE HELPERS)
// ------------------------------------

function is_display_type(display_type) {
	return $('.display-type').css('content') == display_type || $('.display-type').css('content') == '"' + display_type + '"';
}
function not_display_type(display_type) {
	return $('.display-type').css('content') != display_type && $('.display-type').css('content') != '"' + display_type + '"';
}

$(function () {
	// #1. CHAT APP

	$('.floated-chat-btn, .floated-chat-w .chat-close').on('click', function () {
		$('.floated-chat-w').toggleClass('active');
		return false;
	});

	$('.message-input').on('keypress', function (e) {
		if (e.which == 13) {
			$('.chat-messages').append('<div class="message self"><div class="message-content">' + $(this).val() + '</div></div>');
			$(this).val('');
			var $messages_w = $('.floated-chat-w .chat-messages');
			$messages_w.scrollTop($messages_w.prop('scrollHeight'));
			$messages_w.perfectScrollbar('update');
			return false;
		}
	});
 
	// #3. FORM VALIDATION

	if ($('#formValidate').length) {
		$('#formValidate').validator();
	}

	// #4. DATE RANGE PICKER
	

	// #5. DATATABLES

	if ($('#formValidate').length) {
		$('#formValidate').validator();
	}
	if ($('#dataTable1').length) {
		$('#dataTable1').DataTable({ buttons: ['copy', 'excel', 'pdf'] });
	}
	// #6. EDITABLE TABLES

	if ($('#editableTable').length) {
		$('#editableTable').editableTableWidget();
	}

	// #7. FORM STEPS FUNCTIONALITY

	$('.step-trigger-btn').on('click', function () {
		var btn_href = $(this).attr('href');
		$('.step-trigger[href="' + btn_href + '"]').click();
		return false;
	});

	// FORM STEP CLICK
	$('.step-trigger').on('click', function () {
		var prev_trigger = $(this).prev('.step-trigger');
		if (prev_trigger.length && !prev_trigger.hasClass('active') && !prev_trigger.hasClass('complete')) return false;
		var content_id = $(this).attr('href');
		$(this).closest('.step-triggers').find('.step-trigger').removeClass('active');
		$(this).prev('.step-trigger').addClass('complete');
		$(this).addClass('active');
		$('.step-content').removeClass('active');
		$('.step-content' + content_id).addClass('active');
		return false;
	});
	// END STEPS FUNCTIONALITY
 
	// #10. CHARTJS CHARTS http://www.chartjs.org/

	if (typeof Chart !== 'undefined') {
		var fontFamily = '"Proxima Nova W01", -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
		// set defaults
		Chart.defaults.global.defaultFontFamily = fontFamily;
		Chart.defaults.global.tooltips.titleFontSize = 14;
		Chart.defaults.global.tooltips.titleMarginBottom = 4;
		Chart.defaults.global.tooltips.displayColors = false;
		Chart.defaults.global.tooltips.bodyFontSize = 12;
		Chart.defaults.global.tooltips.xPadding = 10;
		Chart.defaults.global.tooltips.yPadding = 8;

	 
	}
 
    // INIT MENU TO ACTIVATE ON HOVER

	var menu_timer;
	$(document).on('mouseenter', '.menu-activated-on-hover ul.main-menu > li.has-sub-menu', (event) => {
		var $elem = $(event.target).closest('li');
		$elem.closest('ul').find('li:not(.active-route)').removeClass('active');
		clearTimeout(menu_timer);
		$elem.addClass('active');
	});

	$(document).on('mouseleave', '.menu-activated-on-hover ul.main-menu > li.has-sub-menu', (event) => {
		var $elem = $(event.target).closest('li');
		menu_timer = setTimeout(function () {
			$elem.closest('ul').find('li:not(.active-route)').removeClass('active');
		}, 200);
	});

	// INIT MENU TO ACTIVATE ON CLICK

	$(document).on('click', '.menu-activated-on-click li.has-sub-menu > a', () => {
		var $elem = $('.menu-activated-on-click li.has-sub-menu > a').closest('li');
		if ($elem.hasClass('active')) {
			$elem.removeClass('active');
		} else {
			$elem.closest('ul').find('li.active').removeClass('active');
			$elem.addClass('active');
		}
		return false;
	});

	// #12. CONTENT SIDE PANEL TOGGLER

	$(document).on('click', '.content-panel-toggler, .content-panel-close, .content-panel-open', () => {
		$('.all-wrapper').toggleClass('content-panel-active');
	});

	// #13. EMAIL APP 

	$(document).on('click', '.more-messages', () => {
		$('.more-messages').hide();
		$('.older-pack').slideDown(100);
		$('.aec-full-message-w.show-pack').removeClass('show-pack');
		return false;
	});

	// EMAIL SIDEBAR MENU TOGGLER
	$(document).on('click', '.ae-side-menu-toggler', () => {
		$('.app-email-w').toggleClass('compact-side-menu');
	});

	// EMAIL MOBILE SHOW MESSAGE
	$(document).on('click', '.ae-item', () => {
		$('.app-email-w').addClass('forse-show-content');
	});

	if ($('.app-email-w').length) {
		if (is_display_type('phone') || is_display_type('tablet')) {
			$('.app-email-w').addClass('compact-side-menu');
		}
	}

	// #14. FULL CHAT APP
	function add_full_chat_message($input) {
		$('.chat-content').append('<div class="chat-message self"><div class="chat-message-content-w"><div class="chat-message-content">' + $input.val() + '</div></div><div class="chat-message-date">1:23pm</div><div class="chat-message-avatar"><img alt="" src="img/avatar1.jpg"></div></div>');
		$input.val('');
		var $messages_w = $('.chat-content-w');
		$messages_w.scrollTop($messages_w.prop('scrollHeight'));
		$messages_w.perfectScrollbar('update');
	}

	$('.chat-content-w').perfectScrollbar({ wheelPropagation: true });

	$('.chat-btn a').on('click', function () {
		add_full_chat_message($('.chat-input input'));
		return false;
	});
	$('.chat-input input').on('keypress', function (e) {
		if (e.which == 13) {
			add_full_chat_message($(this));
			return false;
		}
	});

	// #15. CRM PIPELINE
	// INIT DRAG AND DROP FOR PIPELINE ITEMS
	if ($('.pipeline').length) {
		var dragulaObj = dragula($('.pipeline-body').toArray(), {}).on('drag', function () {}).on('drop', function (el) {}).on('over', function (el, container) {
		$(container).closest('.pipeline-body').addClass('over');
		}).on('out', function (el, container, source) {

		var new_pipeline_body = $(container).closest('.pipeline-body');
		new_pipeline_body.removeClass('over');
		var old_pipeline_body = $(source).closest('.pipeline-body');
		});
	}

	// #16. OUR OWN CUSTOM DROPDOWNS 
	/* $(document).on('click', 'body', () => {
		var element=document.getElementsByClassName('os-dropdown-trigger');
		if(element.classList.contains('over')){
			$(event.target).closest('.os-dropdown-trigger.over').removeClass('over');
			console.log('tOver')
		}
	}); */
	
	$(document).on('click', '.os-dropdown-trigger', (event) => {
		$(event.target).closest('.os-dropdown-trigger').toggleClass('over');
	});
	/* $('.calendar-range-rooming').click(function(event){
		event.stopPropagation();
	}); */
	$(document).on('click', '.board-top-header-os.os-dropdown-trigger', (event) => {
		$(event.target).closest('.os-dropdown-trigger').addClass('over');
	});
	/* const $calendarRangeRooming = $('.calendar-range-rooming');
	$(document).click(e => {
		if (!$calendarRangeRooming.is(e.target) // if the target of the click isn't the container...
		&& $calendarRangeRooming.has(e.target).length === 0) // ... nor a descendant of the container
		{
			$(e.target).closest('.calendar-range-rooming').removeClass('active');
		  console.log('test')
	   }
	  }); */
	
	$(document).on('mouseleave', '.os-dropdown-trigger .os-dropdown', () => {
		$(event.target).closest('.os-dropdown-trigger').removeClass('over');
	});

	// #17. BOOTSTRAP RELATED JS ACTIVATIONS

	// - Activate tooltips
    $('body').tooltip({
		selector: '[data-toggle="tooltip"]'
	});
	
	// - Activate popovers
	$('body').popover({
		selector: '[data-toggle="popover"]'
	});

	// #18. TODO Application

	// Tasks foldable trigger
	$('.tasks-header-toggler').on('click', function () {
		$(this).closest('.tasks-section').find('.tasks-list-w').slideToggle(100);
		return false;
	});

	// Sidebar Sections foldable trigger
	$('.todo-sidebar-section-toggle').on('click', function () {
		$(this).closest('.todo-sidebar-section').find('.todo-sidebar-section-contents').slideToggle(100);
		return false;
	});

	// Sidebar Sub Sections foldable trigger
	$('.todo-sidebar-section-sub-section-toggler').on('click', function () {
		$(this).closest('.todo-sidebar-section-sub-section').find('.todo-sidebar-section-sub-section-content').slideToggle(100);
		return false;
	});

	// Drag init
	if ($('.tasks-list').length) {
		// INIT DRAG AND DROP FOR Todo Tasks
		var dragulaTasksObj = dragula($('.tasks-list').toArray(), {
			moves: function moves(el, container, handle) {
				return handle.classList.contains('drag-handle');
			}
		}).on('drag', function () {}).on('drop', function (el) {}).on('over', function (el, container) {
			$(container).closest('.tasks-list').addClass('over');
		}).on('out', function (el, container, source) {

			var new_pipeline_body = $(container).closest('.tasks-list');
			new_pipeline_body.removeClass('over');
			var old_pipeline_body = $(source).closest('.tasks-list');
		});
	}

	// Task actions init

	// Complete/Done
	$('.task-btn-done').on('click', function () {
		$(this).closest('.draggable-task').toggleClass('complete');
		return false;
	});

	// Favorite/star
	$('.task-btn-star').on('click', function () {
		$(this).closest('.draggable-task').toggleClass('favorite');
		return false;
	});
 
 
});




// WEBPACK FOOTER //
// ./src/vendor/template.js